import {
  EXTERNAL_INVITE_LOGIN_STORAGE_KEY,
  SECONDS_IN_DAY,
} from "@shared/common/constants.ts";
import localStorageService from "utils/localStorageService.ts";
import {
  ExternalInvitationUserData,
  UserImpersonationPermissionLevel,
} from "@shared/types";

export const setExternalInviteLocalStorageLogin = (userId?: number) => {
  if (userId) {
    localStorageService.setJsonValue(EXTERNAL_INVITE_LOGIN_STORAGE_KEY, {
      user_id: userId,
      timestamp: Date.now(),
    });
  } else {
    localStorage?.removeItem(EXTERNAL_INVITE_LOGIN_STORAGE_KEY);
  }
};

export const validateInviteLocalStorageLogin = (userId?: number) => {
  const storageValue = localStorageService.getJsonValue(
    EXTERNAL_INVITE_LOGIN_STORAGE_KEY
  );
  return (
    !!userId &&
    storageValue?.user_id === userId &&
    storageValue.timestamp > Date.now() - 1000 * SECONDS_IN_DAY * 0.5
  );
};

export const getExternalInvitePermissionText = (
  invitation?: ExternalInvitationUserData
) => {
  const isAssetManagerWritePermission =
    invitation?.asset_manager_permission_level ===
    UserImpersonationPermissionLevel.WRITE;
  const isUserWritePermission =
    invitation?.permission_level === UserImpersonationPermissionLevel.WRITE;
  let permissionTextKey = "external_connect.permissions.both_write";
  if (isUserWritePermission && !isAssetManagerWritePermission) {
    permissionTextKey = "external_connect.permissions.user_write";
  } else if (!isUserWritePermission && isAssetManagerWritePermission) {
    permissionTextKey = "external_connect.permissions.asset_manager_write";
  }
  return permissionTextKey;
};
